import { Icon } from '../Icons'

/**
 * Card selezionabile per un viaggiatore trovato in ricerca
 * @param {Object} props - Proprietà del componente
 * @param {string} props.nome - Nome del viaggiatore
 * @param {string} props.cognome - Cognome del viaggiatore
 * @param {string} [props.email] - Email del viaggiatore
 * @param {string} [props.sex] - Sesso (M/F) per variante avatar
 * @param {Function} props.onClick - Callback al click sulla card
 * @returns {JSX.Element} Card viaggiatore
 */
export const TravellersCard = ({ nome, cognome, email = '', sex = '', onClick }) => {
  const sexClass = sex === 'M' ? ' is-male' : sex === 'F' ? ' is-female' : ''

  return (
    <button type="button" className={`gf-traveller-card${sexClass}`} onClick={onClick}>
      <span className="gf-traveller-card__avatar" aria-hidden="true">
        <Icon name="user" size={18} />
      </span>
      <span className="gf-traveller-card__body">
        <span className="gf-traveller-card__name">
          {nome} {cognome}
        </span>
        {email ? <span className="gf-traveller-card__email">{email}</span> : null}
      </span>
      <Icon name="chev_right" size={14} className="gf-traveller-card__chev" />
    </button>
  )
}
